import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const scrollToAnchor = ($) => {
  const header = $('.header');
  const fragment = window.location.hash;
  const scrollToEl = (target, delay = 0) => {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: target,
        offsetY: header.height(),
      },
      delay: delay,
      ease: 'power3.inOut'
    });
  }
  
  // ScrollTo on click
  $('a[href*="#"]').click((e) => {
    const link = $(e.currentTarget);
    const anchorTarget = link.attr('href').split("#")[1];
    const targetEl = $(`#${anchorTarget}`);
    
    // Si la cible est bien sur la page courante
    if (targetEl.length > 0) {
      e.preventDefault();
      scrollToEl(`#${anchorTarget}`);
    }
  });
}

export default scrollToAnchor